import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import api from "../lib/api";
import { t } from "../i18n";

const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView || value == null) return;
    let start;
    const dur = 1800;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / dur, 1);
      setN(Math.round((1 - Math.pow(1 - p, 3)) * value));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return (
    <span ref={ref} className="font-display text-5xl sm:text-6xl font-black gold-gradient-text tabular-nums">
      {n.toLocaleString()}+
    </span>
  );
};

const LABELS = [
  { key: "clients", label: "Clients Assisted" },
  { key: "applications", label: "Applications Supported" },
  { key: "destinations", label: "Destinations" },
  { key: "years", label: "Years of Experience" },
];

const StatsSection = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  if (!stats) return null;
  const visible = LABELS.filter((l) => stats[l.key] != null);
  if (visible.length === 0) return null;

  return (
    <section data-testid="stats-counter-section" className="relative py-20 bg-navy-deep border-y border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-2 gap-10 text-center ${visible.length > 2 ? "lg:grid-cols-4" : "lg:grid-cols-2"}`}>
          {visible.map((l) => (
            <div key={l.key} data-testid={`stat-${l.key}`}>
              <Counter value={stats[l.key]} />
              <p className="mt-3 text-xs sm:text-sm font-semibold tracking-[0.2em] text-slate-400 font-display uppercase">
                {t(`stats.${l.key}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
